import { Col, Container, Row } from "reactstrap";

const Description = () => {
  return (

          <Col lg={12} className="section" id="description">
            <div className="text-center w-75 mx-auto">
              <p className="user-review">
                <span className="fw-bold">Melbourne Polytechnic</span> adalah
                  salah satu penyedia pendidikan vokasi dan pendidikan tinggi 
                  terkemuka di Victoria, Australia, dengan pengalaman lebih 
                  dari 100 tahun dalam mengembangkan keterampilan praktis 
                  dan profesional untuk dunia kerja. Institusi ini menawarkan 
                  lebih dari 170 program mulai dari kursus VET, diploma, 
                  associate degree, hingga gelar sarjana dan kursus singkat, 
                  dengan kurikulum yang menekankan pembelajaran praktis dan 
                  pengalaman langsung melalui fasilitas kelas dan 
                  workshop yang menyerupai lingkungan kerja nyata.
              </p>
            </div>
          </Col>

  );
};

export default Description;